import {Directive, HostBinding, input} from '@angular/core';
import moment from 'moment';


/**
 * This directive helps to draw a vertical rectangle to display a timeslot.
 */
@Directive({
  selector: '[appTimeSlot]',
})
export class TimeSlotDirective {

  /**
   * The earliest time in a grid.
   */
  readonly gridStart = input<string>(undefined);
  /**
   * Start time of an assignment.
   */
  readonly startTime = input<string>(undefined);
  /**
   * End time of an assigment.
   */
  readonly endTime = input<string>(undefined);
  /**
   * Height of one cell in a grid (pixels).
   */
  readonly cellHeight = input<number>(undefined);

  /**
   * Calculates how many pixels from the top should be the start of a rectangle.
   */
  @HostBinding('style.top.px')
  get top(): number {
    return this.getTop();
  }

  /**
   * Calculates the height of a rectangle in pixels.
   */
  @HostBinding('style.height.px')
  get height(): number {
    return this.getHeight();
  }

  private getTop(): number {
    const diff = this.getDiffInMinutes(this.gridStart(), this.startTime());
    return this.cellHeight() + (diff / 60 * this.cellHeight());
  }

  private getHeight(): number {
    const diff = this.getDiffInMinutes(this.startTime(), this.endTime());
    return diff / 60 * this.cellHeight();
  }

  private getDiffInMinutes(startTime: string, endTime: string) {
    const momentStartTime = moment(startTime, 'HH:mm');
    const momentEndTime = moment(endTime, 'HH:mm');
    return momentEndTime.diff(momentStartTime, 'minutes');
  }
}
